/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Template_Aspect_Instagram_StoryInputs */

const cs_template_aspect_instagram_story = /** @type {(inputs: Template_Aspect_Instagram_StoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Instagram stories`)
};

const en_template_aspect_instagram_story = /** @type {(inputs: Template_Aspect_Instagram_StoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Instagram story`)
};

/**
* | output |
* | --- |
* | "Instagram story" |
*
* @param {Template_Aspect_Instagram_StoryInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const template_aspect_instagram_story = /** @type {((inputs?: Template_Aspect_Instagram_StoryInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Template_Aspect_Instagram_StoryInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_template_aspect_instagram_story(inputs)
	return cs_template_aspect_instagram_story(inputs)
});